<!-- Выбор нескольких связанных ремонтов или пометок того же ТС -->
<template>
  <div class="record-list-related-select">
    <slot v-for="record in selectedRecords" :key="record.id" name="record" :record="record" :remove="() => remove(record.id)" />
    <BaseSelect :model-value="null" :options="options" :loading="loading" :disabled="disabled || !vehicleId"
      :placeholder="placeholder"
      searchable external-search :clearable="false" no-results-text="Подходящих записей нет"
      @update:model-value="add" @search="load($event.query)" @clear-search="load()" />
  </div>
</template>
<script>
import {
  appendAssociationList,
  associationListForControl,
  removeAssociationList,
} from "@/utils/associationListUtils";

export default {
  name: "RecordListRelatedSelect",
  props: {
    fetchRecords: { type: Function, required: true },
    recordLabel: { type: Function, required: true },
    placeholder: { type: String, default: "Добавить запись" },
    vehicleId: { type: [Number, String], default: null },
    modelValue: { type: Array, default: undefined },
    initialRecords: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
  },
  emits: ["update:modelValue"],
  data() { return { records: [], knownRecords: [], loading: false, requestId: 0 }; },
  computed: {
    selectedIds() {
      return associationListForControl(this.modelValue);
    },
    selectedRecords() {
      const records = [...this.initialRecords, ...this.knownRecords];
      return this.selectedIds.map((id) => records.find((record) => String(record.id) === String(id)) || { id });
    },
    options() {
      return this.records.filter((record) => !this.selectedIds.some((id) => String(id) === String(record.id)))
        .map((record) => ({ value: record.id, label: this.recordLabel(record) }));
    },
  },
  watch: {
    vehicleId: {
      immediate: true,
      handler(value, previous) {
        this.records = [];
        this.knownRecords = [];
        this.load();
      },
    },
  },
  beforeUnmount() { this.requestId += 1; },
  methods: {
    add(id) {
      if (id == null || this.disabled || this.selectedIds.some((value) => String(value) === String(id))) return;
      this.$emit("update:modelValue", appendAssociationList(this.modelValue, id));
    },
    remove(id) {
      if (this.disabled) return;
      this.$emit(
        "update:modelValue",
        removeAssociationList(this.modelValue, (value) => String(value) === String(id))
      );
    },
    async load(search = "") {
      const request = ++this.requestId;
      this.loading = true;
      try {
        const records = await this.fetchRecords(this.vehicleId, search);
        if (request !== this.requestId) return;
        this.records = records;
        this.knownRecords = [...new Map([...this.knownRecords, ...records].map((record) => [record.id, record])).values()];
      } finally {
        if (request === this.requestId) this.loading = false;
      }
    },
  },
};
</script>
<style scoped>
.record-list-related-select { display: grid; gap: 8px; }
</style>
